<template>
  <VDialogV3
    :entity="localSwPortalTask"
    position="right"
    width="600px"
    @submit="createTask"
  >
    <SWPortalTaskForm :sw-portal-task="localSwPortalTask"/>
  </VDialogV3>
</template>

<script lang="ts">

import type TransportOrder   from '@/domains/TransportOrders/TransportOrder.js';

import SWPortalTask          from "@/domains/SWPortalTask/SWPortalTask";
import SWPortalTasksService  from "@/domains/SWPortalTask/SWPortalTasksService"

import SWPortalTaskForm      from '@/domains/SWPortalTask/components/SWPortalTaskCreateDialog/SWPortalTaskForm';

export default defineComponent({
	name:       'SWPortalTaskCreateDialog',
	components: { SWPortalTaskForm },

  props: {
    transportOrder: {
      type: Object as PropType<TransportOrder>,
      required: true,
    },
  },

  emits: ['close', SWPortalTask.Events.Created],

  setup() {
    return {
      SWPortalTasksService,
    }
  },

  data() {
    return {
      localSwPortalTask: SWPortalTask.fromTransportOrder(this.transportOrder),
      isSaving:          false,
    };
  },

	methods: {
    async createTask() {
      this.isSaving = true;
      try {
        const isCreated = await SWPortalTasksService.create(this.localSwPortalTask);

        if (isCreated) {
          this.$emit(SWPortalTask.Events.Created);
          this.$emit('close');
        }
      } finally {
        this.isSaving = false;
      }
    },
	},
});
</script>
